import React, { useState, useEffect } from 'react'
import { useStateValue } from "./StateProvider";
import { db } from "./firebase";
import MenuItems from "./MenuItems"
import "./Menu.css"

function Menu() {
    const [{ todaysEvent }, saveEvent] = useStateValue();
    const [{ eventDate }] = useStateValue();
    const [menuItems, setMenuItems] = useState()

    useEffect(() => {
        const fetchMenu= async () => {
            const menuCollection = await db
              .collection("menus")
              .doc("specials")
              .collection(eventDate)
              .orderBy("price")
              .get();
            setMenuItems(
              menuCollection.docs.map((doc) => {
                return doc.data();
              })
            
            );
            
          };
        fetchMenu();
      }, []);

  //get specials

  console.log("Menu", menuItems)

  function Night(props) {
    const sex = props.sex;
    if (sex === "M") {
      return "Mens Night";
    } else {
      return "Ladies Night";
    }
  }

    return (
        <div className="menu" >
            <span className="menu__title">{Night(todaysEvent)} Specials</span>
            {menuItems?.map((m)=><MenuItems item= {m} />)}
        </div>
    )
}

export default Menu
